export const environment = {
  environment: "dev",
  apiUrl: 'https://dev.dexbee.ru',
  apiUrl5001: '',
  appleAuthReturnUrl: 'https://lk-dev.dexbee.ru/process',
  appleAuthClientId: 'com.dexbee.sport.backend.dev',
  vkAppId: 54288612,
  vkAuthReturnUrl: 'https://lk-dev.dexbee.ru/main',
  isShowConsoleLog: true,
  terminalId: 'pk_0dc94c2e73f7b9fd87a930fe51f9c'
};
